import { createFeatureSelector, createSelector } from "@ngrx/store";
import { FeatureKeys } from "../app.reducer";
import * as fromReducer from './checklist.reducer';
import { IChecklist } from "@signal/asp-data-commons";

export const selectChecklistFeature = createFeatureSelector<fromReducer.ChecklistState>(
  FeatureKeys.CHECKLIST
);

export const selectAllChecklist = createSelector(
  selectChecklistFeature,
  (state: fromReducer.ChecklistState) => state.allChecklist
);

export const selectOnlineChecklist = createSelector(
  selectChecklistFeature,
  (state: fromReducer.ChecklistState) => state.allChecklist.filter(x => x.status)
);

export const selectAllChecklistLoading = createSelector(
  selectChecklistFeature,
  (state: fromReducer.ChecklistState) => state.loading
);

export const selectAllChecklistCount = createSelector(
  selectAllChecklist,
  (checklist: IChecklist[]) => checklist?.length
);

export const selectOnlineChecklistCount = createSelector(
  selectOnlineChecklist,
  (checklist: IChecklist[]) => checklist?.length
);

export const selectFromChecklist = createSelector(
  selectChecklistFeature,
  (state: fromReducer.ChecklistState) => state.allChecklist.find(x => x.checklistId === state.selectedChecklist)
);
